import * as React from 'react';
import { Route, Switch } from 'react-router';
import { PacksList } from './scenes/PackList';
import { PurchaseWallpapersPacksList } from './scenes/PurchaseWallpapersPackList';

export default class SecuredZone extends React.Component {
  render() {
    return (<Switch>
      <Route path="/" exact component={PacksList}/>
      <Route path="/purchase-wallpapers" exact component={PurchaseWallpapersPacksList}/>
    </Switch>);
  }
}
